// extracted by mini-css-extract-plugin
export default {"container":"Analytics_container__nppQv"};